import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { ClpPopulation, ProductCardImage } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: ClpPopulation.NAME,
        oldNameMatcher: /^clp_population/m,
      },
      {
        newName: ProductCardImage.NAME,
        oldNameMatcher: /^plp_product_card_image/m,
      },
    ],
  });
};
